module.exports = __webpack_public_path__ + "img/23_46.1eeb97a0.png";